// src/usePermissions.js
export const getRoles = () => {
    try { return JSON.parse(localStorage.getItem('roles') || '[]'); }
    catch (e) { return []; }
};

export const hasRole = (role) => getRoles().includes(role);
export const isAdmin = () => hasRole('ROLE_ADMIN');
export const isSuperAdmin = () => localStorage.getItem('is_super_admin') === '1';
export const isResponsabil = () => hasRole('ROLE_RESPONSABIL');
export const getColaboratorId = () => {
    const id = localStorage.getItem('colaborator_id');
    return id ? parseInt(id, 10) : null;
};

// Poate crea/edita/sterge evenimente
export const useCanManage = () => isSuperAdmin() || isAdmin();

// Colaborator simplu - nu e admin, nu e superadmin
// Vede doar evenimentele la care participa si raportul propriu
export const isColaboratorSimple = () => !isSuperAdmin() && !isAdmin();
